import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import {
  applySlip,
  CalAm,
  CalAmBulk,
  getInitFormData,
  getTablebySql,
  setConfigToColumns,
  setUmByFgUm,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global, useMenuStore } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { showPopupModal, showResizablePopupModal } from "@widgets/CommonModal";
import { menuInfo } from "@shared/type/CommonType";
import SnButton from "@shared/components/SnButton";
import SnComboBox from "@shared/components/SnComboBox";
import SnLabel from "@shared/components/SnLabel";
import SN_PUR_APP_REG_001_POP_01 from "./SN_PUR_APP_REG_001_POP_01";
import CommonSpinner from "@widgets/CommonSpinner";
import SnResizeBar from "@shared/components/SnResizeBar";
import { dateToString } from "@shared/utils/DateUtils";
import { RowNode } from "ag-grid-community";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import { executeApprovalSubmit } from "@shared/utils/approval/approvalIntegration";
import { submitApproval } from "@shared/api/approvalSubmitApi";
import {
  buildJsAddinfoFromFlags,
  extractAddInfoFlags,
  hydrateRowsWithAddInfo,
} from "@shared/utils/AddInfoUtils";
import { openAddInfoPopup } from "@widgets/commonpopup/sys/openAddInfoPopup";
interface Props {
  Menuprops: menuInfo;
}

const SN_PUR_APP_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo, config } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });
  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });

  const pur0001 = useRef<any>(null);
  let tpUmValue = useRef<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState<string>("001");
  const isApprovalVisible = config?.MAS0121?.dc_ctrl === "Y";
  const [selectedDocu, setSelectedDocu] = useState<string>(""); // file 관련

  // 한글 주석: grid1(품의정보)/grid2(상세정보)별 부가항목 키(cd_flag) 목록
  // 렌더링에는 쓰이지 않고 조회/저장 시점에만 읽으므로 ref로 둔다.
  // (state로 두면 설정 저장 직후 같은 렌더의 onSearch가 옛 목록을 보게 된다)
  const addInfoFlagsRef = useRef<string[]>([]);
  const addInfoFlags2Ref = useRef<string[]>([]);

  // 한글 주석: 메뉴별 sys_addinfo(cd_flag) 목록을 조회해 js_addinfo 묶기 키로 사용한다.
  const loadAddInfoFlags = async (
    idTarget = "grid1",
    flagsRef = addInfoFlagsRef
  ) => {
    try {
      const data: any = await fnGetDataSet({
        id: "sys_addinfo_pop_01_01",
        params: {
          cd_firm: userInfo?.cd_firm ?? "",
          cd_menu: Menuprops?.cd_menu ?? "",
          id_target: idTarget,
        },
      });
      const flags = extractAddInfoFlags(data?.[0] || []);
      flagsRef.current = flags;
      return flags;
    } catch (error: any) {
      flagsRef.current = [];
      return [];
    }
  };

  // 한글 주석: 화면 메타(getInitFormData) 결과를 그리드 컬럼 설정으로 변환한다.
  const buildGridColumns = (rtn: any) => {
    const configGrid1 = setConfigToColumns(rtn.grid.grid2, "MAS0002");
    const configGrid2 = setConfigToColumns(configGrid1, "PUR0105");
    return {
      grid1: rtn.grid.grid1,
      grid2: configGrid2,
    };
  };

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums(buildGridColumns(rtn));

        // 한글 주석: 초기 진입 시 부가항목 키 목록도 함께 로드한다.
        await loadAddInfoFlags("grid1", addInfoFlagsRef);
        await loadAddInfoFlags("grid2", addInfoFlags2Ref);

        const sqlQuery = {
          sql: "select cd_flag from mas_codel where cd_firm = :cd_firm and cd_clas = 'PUR001' limit 1;",
          cd_firm: userInfo.cd_firm,
        };
        const data = await getTablebySql(sqlQuery);
        if (data && data.length > 0) {
          tpUmValue.current = data[0].cd_flag;
        }
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    if (
      Menuprops.figure &&
      columns.grid1.length > 0 &&
      columns.grid2.length > 0
    ) {
      onActivate(Menuprops.nodeData);
    }
  }, [columns, Menuprops]);

  useEffect(() => {
    const fetchCalm = async () => {
      if (!pur0001.current) {
        // 최초 1번만 조회
        const PUR0001 = {
          sql: "select dc_ctrl from sys_ where cd_firm = :cd_firm and cd_ctrl = 'PUR0001'",
          cd_firm: userInfo.cd_firm,
        };
        pur0001.current = await getTablebySql(PUR0001);
      }
    };
    fetchCalm();
  }, [userInfo.cd_firm]);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async (searchData?: any) => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) return;
      }
    }

    try {
      const params = {
        id: "sn_pur_app_reg_001_01",
        params: searchData || searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);

      // 한글 주석: 조회 결과의 js_addinfo를 동적 부가항목 컬럼으로 펼친다.
      const flags =
        addInfoFlagsRef.current.length > 0
          ? addInfoFlagsRef.current
          : await loadAddInfoFlags("grid1", addInfoFlagsRef);
      const flags2 =
        addInfoFlags2Ref.current.length > 0
          ? addInfoFlags2Ref.current
          : await loadAddInfoFlags("grid2", addInfoFlags2Ref);

      setDataSources({
        grid1: hydrateRowsWithAddInfo(data[0] || [], flags),
        grid2: hydrateRowsWithAddInfo(data[1] || [], flags2),
      });
    } catch (error: any) {}
  };

  const onInsert = () => {
    try {
      const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        showDialog("alter", "수정된 내용이 있습니다.");
        return;
      }

      const today = dateToString(new Date());
      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        no_app: "",
        st_app: "F",
        cd_dept: userInfo.cd_dept,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        no_mar: "",
        dt_app: today,
        cd_gp: userInfo.cd_gp,
      };
      return gridRefs.current["grid1"].current?.addRow(newRow);
    } catch (error: any) {}
  };

  const onBeforeAddRow1 = (): boolean | Record<string, any> => {
    try {
      const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        showDialog("alter", "수정된 내용이 있습니다.");
        return false;
      }

      const today = dateToString(new Date());
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        no_app: "",
        st_app: "F",
        cd_dept: userInfo.cd_dept,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        no_mar: "",
        dt_app: today,
        cd_gp: userInfo.cd_gp,
      };

      return updatedRow;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };

  const onAddRow = () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }
      if (focusedNodeH.data?.st_app === "R") {
        showDialog(
          "alter",
          "승인된 건 입니다.\r\n승인취소 후 진행해주시기 바랍니다."
        );
        return;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      return gridRefs.current["grid2"].current?.addRow({});
    } catch (error: any) {}
  };

  const onBeforeAddRowL = () => {
    try {
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      const maxNoLine =
        gridRefs.current["grid2"].current.getMaxValue("no_line");
      return {
        cd_firm: userInfo.cd_firm,
        am: 0,
        am_k: 0,
        no_line_prq: 0,
        qt: 0,
        qt_po: 0,
        um: 0,
        yn_app: "Y",
        um_k: 0,
        cd_budget: "",
        fg_vat: "21",
        st_app: "F",
        rt_exch: 1,
        cd_exch: "000",
        tp_um: tpUmValue.current,
        dt_dlv: focusedNodeH.data?.dt_app,
        no_app: focusedNodeH.data?.no_app,
        no_line: maxNoLine + 1,
      };
    } catch (error: any) {
      return false;
    }
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) return;

    const focusedRowNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    if (!focusedRowNodeH) return;

    const selectedData = focusedRowNodeH.data;
    if (selectedData.st_app !== "F") {
      await showDialog(
        "alter",
        "승인된 건 입니다. 승인취소 후 진행해주시기 바랍니다."
      );
      return;
    }

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    gridRefs.current["grid2"].current?.deleteAllRows();
    gridRefs.current["grid1"].current?.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return;
    }

    return await onSave();
  };

  const onDeleteRow = async () => {
    if (gridRefs.current["grid2"].current?.getDisplayedRowCount() < 1) return;

    const selectedNode = gridRefs.current["grid2"].current?.focusedRowNode();
    if (!selectedNode) return;

    if (selectedNode?.data.qt_po > 0) {
      await showDialog("alter", "발주 진행된 건 입니다.");
      return;
    }
    gridRefs.current["grid2"].current?.deleteSelectedRows();
    setFooterDataToRow();
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const requiredValuesCheckL =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) return false;

      const purAphChanges = gridRefs.current["grid1"].current.getChange();
      const purAplChanges = gridRefs.current["grid2"].current.getChange();
      const headerInserts = purAphChanges.insert ?? [];
      const lineInserts = purAplChanges.insert ?? [];
      if (headerInserts.length > 0 && lineInserts.length === 0) {
        await showDialog("alter", "저장에 실패했습니다.");
        return false;
      }

      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();
      const noSlip = await applySlip({
        cd_column: "no_app",
        cd_module: Menuprops.cd_module,
        no_line: 2,
        cd_prefix: "",
        dt: focusedRowNodeH.data.dt_app,
        girdrefs: [gridRefs.current["grid1"], gridRefs.current["grid2"]],
        inserts: [purAphChanges, purAplChanges],
        cd_menu: Menuprops.cd_menu,
      });
      gridRefs.current["grid2"].current.applyFilters({ no_app: noSlip });

      // 한글 주석: 저장 시점에 flags가 비어있으면 재조회하여 누락 저장을 방지한다.
      const flagsForSave =
        addInfoFlagsRef.current.length > 0
          ? addInfoFlagsRef.current
          : await loadAddInfoFlags("grid1", addInfoFlagsRef);
      const flagsForSave2 =
        addInfoFlags2Ref.current.length > 0
          ? addInfoFlags2Ref.current
          : await loadAddInfoFlags("grid2", addInfoFlags2Ref);

      // 한글 주석: 저장 직전에 변경행의 동적 부가항목 컬럼값을 js_addinfo로 묶는다.
      const withAddInfo = (changes: any, flags: string[]) => ({
        ...changes,
        insert: (changes.insert ?? []).map((row: any) => ({
          ...row,
          js_addinfo: buildJsAddinfoFromFlags(row, flags),
        })),
        update: (changes.update ?? []).map((row: any) => ({
          ...row,
          js_addinfo: buildJsAddinfoFromFlags(row, flags),
        })),
      });

      const saveData = {
        pur_apph: withAddInfo(purAphChanges, flagsForSave),
        pur_appl: withAddInfo(purAplChanges, flagsForSave2),
      };
      const ok = await fnSave("SN_PUR_APP_REG_001_SAVE_01", saveData);
      if (!ok) return;

      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid1"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      return false;
    }
  };

  const onActivate = async (nodeData: any) => {
    if (!nodeData) return;
    setIsLoading(true);
    try {
      if ((Menuprops.figure as string) === "fg_drilldown.Registration") {
        const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
        const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
        if (
          modifiedRowsH.modifiedRowcount > 0 ||
          modifiedRowsL.modifiedRowcount > 0
        ) {
          const confirm = await showDialog(
            "confirmCancel",
            "수정된 내용이 있습니다. 저장하시겠습니까?"
          );
          if (confirm === true) {
            await onSave();
            await setDrilldown();
            return;
          } else if (confirm === false) {
            setDataSources({ grid1: [], grid2: [] });
            gridRefs.current["grid1"].current.resetUpdate();
            gridRefs.current["grid2"].current.resetUpdate();
            await setDrilldown();
            return;
          } else {
            return;
          }
        } else {
          await setDrilldown();
        }
      } else if ((Menuprops.figure as string) === "fg_drilldown.Search") {
        // 발주등록 등 그리드의 품의번호 더블클릭 → 해당 품의 조회
        const selectedData = {
          cd_firm: nodeData.cd_firm,
          cd_biz: nodeData.cd_biz,
          dt_from: nodeData.dt_start ?? nodeData.dt_dlv,
          dt_to: nodeData.dt_start ?? nodeData.dt_dlv,
          cd_cust: "",
          cd_gp: "",
          cd_emp: "",
          cd_pjt: "",
          fg_search: nodeData.no_app ?? "",
          fg_item: "",
          dc_search: "",
        };
        setFormData(selectedData);
        await onSearch(selectedData);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const setDrilldown = async () => {
    const drill = {
      cd_firm: userInfo?.cd_firm,
      cd_biz: searchRef.current.getFormdata().cd_biz,
      no_prq: Menuprops.nodeData[0],
      no_line: Menuprops.nodeData[1],
    };

    const params = {
      id: "sn_pur_app_reg_001_rightclick",
      params: drill,
    };
    const data = await fnGetDataSet(params);

    const headerResult = data[0];
    const lineResult = data[1];

    if (headerResult && headerResult.length > 0) {
      const addedNodeH = onInsert();
      if (addedNodeH) {
        addedNodeH.setSelected(true);
        for (const key in headerResult[0]) {
          if (headerResult[0][key]) {
            addedNodeH.setDataValue(key, headerResult[0][key]);
          }
        }
      }
    }
    if (lineResult) {
      lineResult.map((result: any) => {
        const addedNodeL = onAddRow();
        if (addedNodeL) {
          addedNodeL.setSelected(true);
          for (const key in result) {
            if (key === "no_line") {
              // no_line → no_line_prq 에만 세팅
              addedNodeL.setDataValue("no_line_prq", result[key]);
            } else {
              // 나머지는 원래대로 세팅
              addedNodeL.setDataValue(key, result[key]);
            }
          }
        }
      });
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_app = selectedRow.no_app;
      setSelectedDocu(no_app);
    } else {
      return;
    }
  };

  // 부가항목설정 팝업 호출
  // 부가항목 설정 팝업을 열고 저장 시 화면 메타/데이터를 재적용한다.
  const onOpenAddInfoPopup = async (idTarget = "grid1") => {
    // id_target에 해당하는 현재 컬럼 메타를 설정 팝업으로 전달한다.
    const columnInfos =
      idTarget === "grid2" ? columns.grid2 || [] : columns.grid1 || [];
    const saved = await openAddInfoPopup({
      cd_menu: Menuprops.cd_menu!,
      id_target: idTarget,
      columnInfos,
    });
    if (!saved) return;

    const rtn: any = await getInitFormData({});
    setFormControlData(rtn.formControlData);
    setFormData((prev: any) => ({
      ...(rtn.formData || {}),
      ...(prev || {}),
    }));
    setColums(buildGridColumns(rtn));

    // 한글 주석: 항목설정 변경 후 부가항목 키 목록을 다시 로드한다.
    // ref에 즉시 반영되므로 바로 아래 onSearch가 갱신된 목록으로 조회한다.
    idTarget === "grid2"
      ? await loadAddInfoFlags(idTarget, addInfoFlags2Ref)
      : await loadAddInfoFlags(idTarget, addInfoFlagsRef);

    await onSearch();
  };

  // grid1 헤더 우클릭 추가 메뉴를 처리한다.
  const onGrid1ExtraHeaderMenuClick = async (event: {
    id: string;
    params: any;
  }) => {
    if (event.id === "extra_item_setting") {
      await onOpenAddInfoPopup("grid1");
    }
  };

  // grid2 헤더 우클릭 추가 메뉴를 처리한다.
  const onGrid2ExtraHeaderMenuClick = async (event: {
    id: string;
    params: any;
  }) => {
    if (event.id === "extra_item_setting") {
      await onOpenAddInfoPopup("grid2");
    }
  };

  const onGrid1BtnsClick = async (id: string) => {
    if (id == "aButton_Approve") {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();

      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
      const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
      const hasModified =
        modifiedRowsH.modifiedRowcount > 0 ||
        modifiedRowsL.modifiedRowcount > 0;
      if (hasModified) {
        const confirm = await showDialog(
          "confirm",
          "수정된 내용이 있습니다. 저장 후 결재상신 하시겠습니까?"
        );
        if (!confirm) return;
        const isSaved: any = await onSave();
        if (!isSaved) return;
      }

      if (!focusedNodeH?.data?.no_app) {
        await showDialog("alter", "결재상신할 품의건을 선택해 주세요.");
        return;
      }

      if (focusedNodeH.data.st_app !== "F") {
        await showDialog("alter", "미승인 상태인 건만 결재상신할 수 있습니다.");
        return;
      }

      await executeApprovalSubmit({
        menuCode: "SN_PUR_APP_REG_001",
        noRef: focusedNodeH.data.no_app,
        userInfo: {
          cd_firm: userInfo.cd_firm,
          cd_biz: userInfo.cd_biz,
          cd_dept: userInfo.cd_dept,
          cd_emp: userInfo.cd_emp,
          cd_user: userInfo.cd_user,
        },
        submitApproval,
        showDialog,
        openWindow: (url) => window.open(url),
        noUrlMessage: "결재창 URL을 수신하지 못했습니다.",
      });
      return;
    }

    if (id == "aButton_ApproveORCancel") {
      const purAphChanges =
        gridRefs.current["grid1"].current.getChange().insert;
      if (purAphChanges.length != 0) {
        await showDialog(
          "alter",
          "수정중인 건이 있습니다. 저장 후 진행하시기 바랍니다."
        );
        return;
      }

      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH) {
        let qt_po = false;
        if (focusedNodeH.data?.st_app == "R") {
          gridRefs.current["grid2"].current.forEachFilteredNode(
            (node: RowNode) => {
              if (node.data.qt_po > 0) {
                showDialog("alter", `발주 진행된 건 입니다.`);
                qt_po = true;
                return;
              }
            }
          );
        }
        if (qt_po) return;
        let active = false;
        let str_st_app;
        if (focusedNodeH.data?.st_app == "F") {
          str_st_app = "R";
          active = true;
        } else if (focusedNodeH.data?.st_app == "R") {
          str_st_app = "F";
          active = true;
        }
        if (active) {
          focusedNodeH.setDataValue("st_app", str_st_app);
          const isSaved = await onSave();
          if (isSaved)
            gridRefs.current["grid2"].current.applyFilters({
              no_app: focusedNodeH.data.no_app,
            });
        }
      }
    }
    if (id == "aButton_ApplyRequest") {
      const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
      if (rowCount === 0) return;

      const purPohChanges =
        gridRefs.current["grid1"].current.getChange().insert;
      if (purPohChanges.length === 0) {
        const selectedNode = gridRefs.current["grid1"].current.focusedRowNode();
        const selectedData = selectedNode?.data;
        if (selectedData.st_app === "R") {
          await showDialog("alter", "승인된 건 입니다.");
          return;
        } else if (selectedData.st_app !== "R") {
        } else {
          await showDialog("alter", "신규행을 추가하시기 바랍니다.");
          return;
        }
      }

      const component = <SN_PUR_APP_REG_001_POP_01 />;
      const result = await showResizablePopupModal({
        title: "요청적용",
        children: component,
      });
      if (!result || result === "close") return;
      const headerResult: any = result[0];
      const lineResult: any = result[1];
      const focusedRowNodeH = getGridCurrent("grid1").focusedRowNode();
      if (focusedRowNodeH && headerResult[0]) {
        for (const key in headerResult[0]) {
          focusedRowNodeH.setDataValue(key, headerResult[0][key]);
        }
      }
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      let no_app = focusedNodeH.data.no_app;

      lineResult.map((result: any) => {
        if (headerResult[0]) {
          const addedNode = onAddRow();
          addedNode.setDataValue("cd_item", result.cd_item, "noEvent");
          addedNode.setDataValue("nm_item", result.nm_item, "noEvent");
          addedNode.setDataValue(
            "dc_item_spec",
            result.dc_item_spec,
            "noEvent"
          );
          addedNode.setDataValue(
            "dc_item_unit",
            result.dc_item_unit,
            "noEvent"
          );
          addedNode.setDataValue("cd_cust", result.cd_cust, "noEvent");
          addedNode.setDataValue("nm_cust", result.nm_cust, "noEvent");
          addedNode.setDataValue(
            "nm_cust_sort",
            result.nm_cust_sort,
            "noEvent"
          );
          addedNode.setDataValue("dt_dlv", result.dt_dlv, "noEvent");
          addedNode.setDataValue("qt", result.qt, "noEvent");
          addedNode.setDataValue("um", result.um, "noEvent");
          addedNode.setDataValue("am", result.am, "noEvent");
          addedNode.setDataValue("am_k", result.am, "noEvent");
          addedNode.setDataValue("no_line_prq", result.no_line, "noEvent");
          addedNode.setDataValue("no_prq", result.no_prq, "noEvent");
          addedNode.setDataValue("cd_pjt", result.cd_pjt, "noEvent");
          addedNode.setDataValue("nm_pjt", result.nm_pjt, "noEvent");
          addedNode.setDataValue("no_wbs", result.no_wbs, "noEvent");
          addedNode.setDataValue("no_cbs", result.no_cbs, "noEvent");
          addedNode.setDataValue("yn_app", "Y", "noEvent");
          addedNode.setDataValue("cd_budget", "", "noEvent");
          addedNode.setDataValue("fg_vat", "21", "noEvent");
          addedNode.setDataValue("st_app", "F", "noEvent");
          addedNode.setDataValue("rt_exch", 1, "noEvent");
          addedNode.setDataValue("cd_exch", "000", "noEvent");
          addedNode.setDataValue("tp_um", tpUmValue, "noEvent");
          addedNode.setDataValue("no_app", no_app, "noEvent");
          addedNode.setDataValue("yn_condition", "Y", "noEvent");
          addedNode.setDataValue("um_k", addedNode.data.um * 1, "noEvent");
          // gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
          //   if (node?.data) {
          //     node.setDataValue("um_k",
          //       node.data.um * node.data.rt_exch);
          //   }
          // });
          gridRefs.current["grid2"].current.applyTransaction({
            update: [result],
          });
        }
      });
    }
  };

  const onGrid2BtnsClick = async (id: string) => {
    if (id == "addRow") {
      onAddRow();
    }
    if (id == "deleteRow") {
      onDeleteRow();
    }
    if (id === "aButton_ChangeUm") {
      const rowCount = gridRefs.current["grid2"].current.getDisplayedRowCount();
      if (rowCount === 0) return;

      try {
        const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
        if (focusedNodeH) {
          if (focusedNodeH.data?.st_app === "R") {
            await showDialog(
              "alter",
              "승인된 건 입니다.\r\n승인취소 후 진행해주시기 바랍니다."
            );
            return;
          }
        }

        let displayedNodes: any[] = [];
        gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) =>
          displayedNodes.push(node)
        );

        await setUmByFgUm(
          gridRefs.current["grid1"],
          gridRefs.current["grid2"],
          "dt_app",
          selectedValue,
          displayedNodes
        );

        displayedNodes.forEach((node: RowNode) => {
          node.setDataValue("tp_um", selectedValue);
        });

        await CalAmBulk(
          gridRefs.current["grid1"],
          gridRefs.current["grid2"],
          "rt_exch"
        );
      } catch (error) {
        console.error(error);
      }
    }
    if (id == "aButton_ApplyRecentUm") {
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH?.data?.st_app === "R") {
        await showDialog(
          "alter",
          "승인된 건 입니다.\r\n승인취소 후 진행해주시기 바랍니다."
        );
        return;
      }

      let displayedNodes: any[] = [];
      gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) =>
        displayedNodes.push(node)
      );
      for (const node of displayedNodes) {
        if (!node?.data) continue;
        const params = {
          id: "sn_pur_app_reg_002_searchum",
          params: {
            cd_firm: userInfo?.cd_firm ?? "",
            cd_item: node.data?.cd_item ?? "",
            cd_cust: node.data?.cd_cust ?? "",
            cd_exch: node.data?.cd_exch ?? "",
          },
        };

        const data: any = await fnGetDataSet(params);
        if (
          Array.isArray(data) &&
          data.length > 0 &&
          Array.isArray(data[0]) &&
          data[0].length > 0
        ) {
          const umValue = data[0][0]?.um;
          if (umValue !== undefined && umValue !== 0) {
            node.setDataValue("um", umValue);
          }
        }
        await CalAmBulk(
          gridRefs.current["grid1"],
          gridRefs.current["grid2"],
          "rt_exch"
        );
      }
    }
  };

  const onCellValueChanged = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    if (!focusedNodeH) return;

    if (colId === "qt" || colId === "um" || colId === "am") {
      await CalAm(gridRefs.current["grid1"], gridRefs.current["grid2"], colId);
    }

    if (colId === "tp_um" || colId === "cd_exch") {
      await setUmByFgUm(
        gridRefs.current["grid1"],
        gridRefs.current["grid2"],
        "dt_app",
        event.rowData.tp_um,
        [event.rowNode]
      );
    }

    if (colId === "cd_cust") {
      const rowCount = gridRefs.current["grid2"].current.getDisplayedRowCount();
      if (rowCount === 1) return;
      if (!rowData.cd_cust) return;

      let apply = false;
      gridRefs.current["grid2"].current?.forEachFilteredNode(
        (node: RowNode) => {
          if (
            node.data[colId] === "" ||
            node.data[colId] === null ||
            node.data[colId] === undefined
          )
            apply = true;
        }
      );
      if (!apply) return;

      const confirm = await showDialog(
        "confirm",
        "일괄적용하시겠습니까?(비어있는 칸이 채워집니다.)"
      );
      const updatedNodes: RowNode[] = [];
      if (confirm) {
        gridRefs.current["grid2"].current?.forEachFilteredNode(
          (node: RowNode) => {
            if (
              node.data.cd_cust === "" ||
              node.data.cd_cust === null ||
              node.data.cd_cust === undefined
            ) {
              node.setDataValue("cd_cust", rowData.cd_cust);
              node.setDataValue("nm_cust", rowData.nm_cust);
              node.setDataValue("nm_cust_sort", rowData.nm_cust_sort);
              updatedNodes.push(node);
            }
          }
        );
        gridRefs.current["grid2"].current.stopEditing();
      }
      await setUmByFgUm(
        gridRefs.current["grid1"],
        gridRefs.current["grid2"],
        "dt_app",
        rowData.tp_um,
        updatedNodes
      );
    }
    if (colId === "tp_um" || colId === "cd_exch") {
      await setUmByFgUm(
        gridRefs.current["grid1"],
        gridRefs.current["grid2"],
        "dt_app",
        event.rowData.tp_um,
        [event.rowNode]
      );
    }
    if (colId === "cd_pjt") {
      const rowCount = gridRefs.current["grid2"].current.getDisplayedRowCount();
      if (rowCount === 1) return;
      if (!rowData.cd_pjt) return;

      let apply = false;
      gridRefs.current["grid2"].current?.forEachFilteredNode(
        (node: RowNode) => {
          if (
            node.data[colId] === "" ||
            node.data[colId] === null ||
            node.data[colId] === undefined
          )
            apply = true;
        }
      );
      if (!apply) return;

      const confirm = await showDialog(
        "confirm",
        "일괄적용하시겠습니까?(비어있는 칸이 채워집니다.)"
      );

      if (confirm) {
        gridRefs.current["grid2"].current?.forEachFilteredNode(
          (node: RowNode) => {
            if (
              node.data.cd_pjt === "" ||
              node.data.cd_pjt === null ||
              node.data.cd_pjt === undefined
            ) {
              node.setDataValue("cd_pjt", rowData.cd_pjt);
              node.setDataValue("nm_pjt", rowData.nm_pjt);
            }
          }
        );
      }
    }
  };

  const setFooterDataToRow = () => {
    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    const footerData = gridRefs.current["grid2"].current.getFooterData();
    if (focusedNodeH) {
      focusedNodeH.setDataValue("am", footerData.am);
      focusedNodeH.setDataValue("am_k", footerData.am_k);
      focusedNodeH.setDataValue("am_vat", footerData.am_vat);
      focusedNodeH.setDataValue("am_supply", footerData.am_supply);
    }
  };

  const onAfterPopupClose = async (event: any) => {
    const applyNodes = event.nodes;
    const colId = event.colId;
    if (colId === "cd_item" || colId === "cd_cust") {
      const footerData = gridRefs.current["grid2"].current.getFooterData();
      await setUmByFgUm(
        gridRefs.current["grid1"],
        gridRefs.current["grid2"],
        "dt_app",
        footerData.tp_um,
        applyNodes
      );
    }
  };

  const handleContextMenu = (params: any) => {
    const menuItems = useMenuStore.getState().menuItems;
    switch (params) {
      case "fn_sn_pur_com_por_reg_01": //발주등록
        const selectedDataH =
          gridRefs.current["grid1"].current.getSelectedRows();
        const selectedStapp = selectedDataH.st_app;
        if (selectedStapp.toString() === "F") {
          showDialog("alter", "승인된 건만 처리가 가능합니다.");
          return;
        }
        const selectedRowH =
          gridRefs.current["grid1"].current.getSelectedRows();
        const selectedRowL =
          gridRefs.current["grid2"].current.getSelectedRows();
        let noLine = "";

        selectedRowL.forEach((row: any) => {
          noLine += row.no_line + "|";
        });

        const primaryData = [selectedRowH[0].no_app, noLine];
        const targetMenu = menuItems
          ? menuItems.find(
              (item: any) => item?.cd_menu === "SN_PUR_POR_REG_001"
            )
          : undefined;
        if (targetMenu) {
          const filePathStr =
            `./${targetMenu.cd_module}/${targetMenu.cd_menu}/${targetMenu.cd_menu}`.toUpperCase();

          (window as any).onActivate(
            targetMenu.cd_menu, // 메뉴 키
            targetMenu.nm_menu, // 메뉴 제목
            targetMenu.cd_module, // 모듈
            filePathStr, // 파일 경로
            targetMenu, // 데이터
            targetMenu.nm_path,
            primaryData,
            "fg_drilldown.Registration",
            Menuprops.cd_menu
          );
        }
        break;

      default:
    }
  };

  const onValueChanged = async (value: string) => {
    setSelectedValue(value);
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
          onExtraHeaderMenuClick: onGrid1ExtraHeaderMenuClick,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onBeforeAddRow: onBeforeAddRowL,
          onCellValueChanged: onCellValueChanged,
          onBtnAddClick: onGrid2BtnsClick,
          onBtnDeleteClick: onGrid2BtnsClick,
          onContextMenu: handleContextMenu,
          onAfterPopupClose: onAfterPopupClose,
          onExtraHeaderMenuClick: onGrid2ExtraHeaderMenuClick,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <CommonSpinner isLoading={isLoading} />
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="49.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "품의정보",
              extraHeaderMenuItems: [
                { id: "extra_item_setting", name: "부가항목설정" },
              ],
            }}
            events={grids.grid1.events}
            filter={{ refs: [gridRefs.current["grid2"]], columns: ["no_app"] }}
            header={
              <div>
                {/*승인/취소 주석처리 ISS2026030170*/}
                {/* <SnButton
                  text={"승인/취소"}
                  onClick={() => {
                    onGrid1BtnsClick("aButton_ApproveORCancel");
                  }}
                /> */}
                <SnButton
                  text={"요청적용"}
                  onClick={() => {
                    onGrid1BtnsClick("aButton_ApplyRequest");
                  }}
                />
                {isApprovalVisible && (
                  <SnButton
                    text={"결재상신"}
                    onClick={() => {
                      onGrid1BtnsClick("aButton_Approve");
                    }}
                  />
                )}
              </div>
            }
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="49.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{
              rowSelection: "multiple",
              title: "상세정보",
              extraHeaderMenuItems: [
                { id: "extra_item_setting", name: "부가항목설정" },
              ],
            }}
            events={grids.grid2.events}
            header={
              <div className="relative flex space-x-3">
                <SnLabel text="단가유형" type="string"></SnLabel>
                <div style={{ width: 150 }}>
                  <SnComboBox
                    defaultValue={"001"}
                    code="PUR001"
                    sql=""
                    isEditable={true}
                    onValueChanged={onValueChanged}
                  />
                </div>
                <div style={{ width: 120 }}>
                  <SnButton
                    text={"단가일괄변경"}
                    onClick={() => {
                      onGrid2BtnsClick("aButton_ChangeUm");
                    }}
                  />
                </div>
                <div style={{ width: 120 }}>
                  <SnButton
                    text={"최근단가적용"}
                    onClick={() => {
                      onGrid2BtnsClick("aButton_ApplyRecentUm");
                    }}
                  />
                </div>
              </div>
            }
          />
        </SnResizeBar>
        <SnFileUploadBox selectedDocu={selectedDocu} selectedLineDocu={0} />
      </div>
    </div>
  );
});

export default SN_PUR_APP_REG_001;
